import useAppStore from "@/store/use-app-store";
import { ExitToApp } from "@mui/icons-material";
import { Avatar, Box, Button, Typography } from "@mui/material";
import React from "react";
import { useAuth } from "react-oidc-context";
// import { useAuth } from "react-oidc-context";

export const handleLogout = (auth) => {
  localStorage.clear();
  auth?.removeUser();
  auth?.clearStaleState();
  try {
    auth?.signoutRedirect({
      extraQueryParameters: { prompt: "none" },
      ...(auth?.user?.id_token ? { id_token_hint: auth?.user?.id_token } : {}),
    });
  } catch (error) {
    console.log(error);
    try {
      auth?.signinRedirect();
    } catch (error) {
      console.log(error);
      const logoutUrl = new URL(
        "https://login.5systems.ru/realms/5systems/protocol/openid-connect/logout",
      );
      if (auth?.user?.id_token) {
        logoutUrl.searchParams.append(
          "post_logout_redirect_uri",
          process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || window.location.origin,
        );
        logoutUrl.searchParams.append(
          "id_token_hint",
          auth?.user?.id_token || "",
        );
      }
      logoutUrl.searchParams.append("prompt", "none");
      window.location.replace(logoutUrl.toString());
    }
  }
};

export function SettingsExitButton(properties) {
  // const auth = useAuth();
  const auth = useAuth();

  return (
    <React.Fragment>
      <Box
        sx={{
          alignSelf: "center",
          maxWidth: "820px",
          padding: "6px 18px",
          textAlign: "start",
          width: "100%",
        }}
      >
        <Button
          color="inherit"
          disableRipple
          fullWidth
          onClick={() => handleLogout(auth)}
          startIcon={<ExitToApp />}
          // sx={{ margin: "0 12px" }}
          variant="outlined"
        >
          Выйти
        </Button>
      </Box>
    </React.Fragment>
  );
}
